import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { FileQuestion } from "lucide-react";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center text-center py-24 gap-4 tr-fade-up">
      <div className="h-16 w-16 rounded-2xl bg-primary/10 flex items-center justify-center">
        <FileQuestion className="h-8 w-8 text-primary" />
      </div>
      <h1 className="font-display text-2xl font-bold">Page not found</h1>
      <p className="text-sm text-muted-foreground max-w-sm">
        The page you're looking for doesn't exist or may have been moved.
      </p>
      <Button onClick={() => navigate("/")}>Back to library</Button>
    </div>
  );
}
